import { sanitizeConsultationFormRules } from 'bl/consultationForms/sanitizeConsultationFormRules.util';
import actionFe from 'utils/mw/actionFe.util';

import { EXPIRATION_PERIOD, FORM_AUTOMATION_TYPES, FORM_FREQUENCY, FORM_STATUS, SERVICE_SELECTION } from './consultationForms.const';
import { getNextId } from './consultationForms.mock';

export const feConsultationFormsFetchSuccess = actionFe('feConsultationFormsFetchSuccess');
export const feConsultationFormCreate = actionFe('feConsultationFormCreate');
export const feConsultationFormUpdate = actionFe('feConsultationFormUpdate');
export const feConsultationFormDelete = actionFe('feConsultationFormDelete');
export const feConsultationFormToggleStatus = actionFe('feConsultationFormToggleStatus');
export const feConsultationFormDuplicate = actionFe('feConsultationFormDuplicate');

export const createConsultationForm = (formData) => (dispatch) => {
  const newForm = { ...formData, id: getNextId() };
  dispatch(feConsultationFormCreate(newForm));
  return newForm;
};

// TODO: this will probably be deleted if BE handles the duplication logic, as we will just make a POST request and invalidate the cache
export const duplicateConsultationForm = (formId) => (dispatch, getState) => {
  const forms = getState().settings.consultationForms.forms;
  const original = forms.find((f) => f.id === formId);
  if (!original) return;

  const duplicate = {
    ...original,
    id: getNextId(),
    name: `${original.name} (copy)`,
    status: 'draft',
    questions: original.questions.map((q) => ({
      ...q,
      id: `q_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
    })),
  };
  dispatch(feConsultationFormDuplicate(duplicate));
};

const EXPIRY_LABELS = {
  '3_months': '3 months expiry',
  '6_months': '6 months expiry',
  '12_months': '12 months expiry',
};

const deriveRuleTags = (rules) => {
  const tags = [];

  if (rules.trigger_type !== FORM_AUTOMATION_TYPES.MANUAL) {
    const servicesLabel = rules.service_selection_type === SERVICE_SELECTION.ALL ? 'All services' : `Selected services (${rules.service_ids?.length ?? 0})`;
    tags.push({ emoji: '📋', category: 'Services', label: servicesLabel });

    const frequencyLabel = rules.frequency === FORM_FREQUENCY.ONCE_PER_CLIENT ? 'Once per client' : 'Every appointment';
    tags.push({ emoji: '🔁', category: 'Frequency', label: frequencyLabel });
  }

  if (rules.expiration_period !== EXPIRATION_PERIOD.NEVER && rules.frequency !== FORM_FREQUENCY.EVERY_APPOINTMENT) {
    tags.push({ emoji: '⏳', category: 'Expires after', label: EXPIRY_LABELS[rules.expiration_period] });
  }

  return tags;
};

export const feSetConsultationFormRules =
  ({ formId, rules }) =>
  (dispatch) => {
    const sanitizedRules = sanitizeConsultationFormRules(rules);
    const ruleTags = deriveRuleTags(sanitizedRules);
    dispatch(feConsultationFormUpdate({ id: formId, rules: sanitizedRules, ruleTags }));
  };

export const feActivateConsultationForm = (formId) => (dispatch) => {
  dispatch(feConsultationFormUpdate({ id: formId, status: FORM_STATUS.ACTIVE }));
};

export const feSetConsultationFormDraft = (formId) => (dispatch) => {
  dispatch(feConsultationFormUpdate({ id: formId, status: FORM_STATUS.DRAFT }));
};
